import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './app/App'
import { installSdk } from './sdk/runtime'
import './styles/index.css'

// Before anything can load a tenant extension.
installSdk()

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <App />
    </StrictMode>,
)
